<template>
  <div class="stats-container">
    <div class="header">
      <h1 class="title">黄牌红牌角球统计</h1>
    </div>

    <div class="stats-content">
      <!-- 黄牌统计 -->
      <div class="stat-card">
        <div class="stat-label">黄牌</div>
        <div class="teams-stats">
          <!-- 主队 -->
          <div class="team-stat">
            <div class="team-label">主队</div>
            <div class="stat-controls">
              <button 
                class="btn btn-minus" 
                @click="decreaseHomeYellowCards"
                :disabled="homeYellowCards <= 0"
              >
                <span class="btn-icon">−</span>
              </button>
              <div class="stat-value">{{ homeYellowCards }}</div>
              <button 
                class="btn btn-plus" 
                @click="increaseHomeYellowCards"
              >
                <span class="btn-icon">+</span>
              </button>
            </div>
          </div>
          <!-- 客队 -->
          <div class="team-stat">
            <div class="team-label">客队</div>
            <div class="stat-controls">
              <button 
                class="btn btn-minus" 
                @click="decreaseAwayYellowCards"
                :disabled="awayYellowCards <= 0"
              >
                <span class="btn-icon">−</span>
              </button>
              <div class="stat-value">{{ awayYellowCards }}</div>
              <button 
                class="btn btn-plus" 
                @click="increaseAwayYellowCards"
              >
                <span class="btn-icon">+</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- 红牌统计 -->
      <div class="stat-card">
        <div class="stat-label">红牌</div>
        <div class="teams-stats">
          <!-- 主队 -->
          <div class="team-stat">
            <div class="team-label">主队</div>
            <div class="stat-controls">
              <button 
                class="btn btn-minus" 
                @click="decreaseHomeRedCards"
                :disabled="homeRedCards <= 0"
              >
                <span class="btn-icon">−</span>
              </button>
              <div class="stat-value">{{ homeRedCards }}</div>
              <button 
                class="btn btn-plus" 
                @click="increaseHomeRedCards"
              >
                <span class="btn-icon">+</span>
              </button>
            </div>
          </div>
          <!-- 客队 -->
          <div class="team-stat">
            <div class="team-label">客队</div>
            <div class="stat-controls">
              <button 
                class="btn btn-minus" 
                @click="decreaseAwayRedCards"
                :disabled="awayRedCards <= 0"
              >
                <span class="btn-icon">−</span>
              </button>
              <div class="stat-value">{{ awayRedCards }}</div>
              <button 
                class="btn btn-plus" 
                @click="increaseAwayRedCards"
              >
                <span class="btn-icon">+</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- 角球统计 -->
      <div class="stat-card">
        <div class="stat-label">角球</div>
        <div class="teams-stats">
          <!-- 主队 -->
          <div class="team-stat">
            <div class="team-label">主队</div>
            <div class="stat-controls">
              <button 
                class="btn btn-minus" 
                @click="decreaseHomeCorners"
                :disabled="homeCorners <= 0"
              >
                <span class="btn-icon">−</span>
              </button>
              <div class="stat-value">{{ homeCorners }}</div>
              <button 
                class="btn btn-plus" 
                @click="increaseHomeCorners"
              >
                <span class="btn-icon">+</span>
              </button>
            </div>
          </div>
          <!-- 客队 -->
          <div class="team-stat">
            <div class="team-label">客队</div>
            <div class="stat-controls">
              <button 
                class="btn btn-minus" 
                @click="decreaseAwayCorners"
                :disabled="awayCorners <= 0"
              >
                <span class="btn-icon">−</span>
              </button>
              <div class="stat-value">{{ awayCorners }}</div>
              <button 
                class="btn btn-plus" 
                @click="increaseAwayCorners"
              >
                <span class="btn-icon">+</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- 重置按钮 -->
      <div class="reset-section">
        <button class="btn-reset" @click="resetAllStats">重置全部</button>
      </div>
      
      <!-- 保存提示 -->
      <transition name="fade">
        <div v-if="saveTip" class="save-tip">已保存</div>
      </transition>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'

export default {
  name: 'HuangpaiHongpaiJiaoqiu',
  setup() {
    const route = useRoute()
    
    // 主队数据
    const homeYellowCards = ref(0)
    const homeRedCards = ref(0)
    const homeCorners = ref(0)
    
    // 客队数据
    const awayYellowCards = ref(0)
    const awayRedCards = ref(0)
    const awayCorners = ref(0)
    
    const saveTip = ref(false)
    const loading = ref(false)
    let saveTipTimer = null
    
    // 存储 team_id 和 match_id
    const homeTeamId = ref(null)
    const awayTeamId = ref(null)
    const matchId = ref(null)

    // 获取统计数据
    const fetchStatistics = async () => {
      const currentMatchId = route.query.match_id || route.params.match_id
      if (!currentMatchId) {
        console.warn('未找到 match_id，跳过获取统计数据')
        return
      }
      
      matchId.value = currentMatchId
      loading.value = true
      
      try {
        const response = await fetch(`https://api.zctj16888.com/app/v1/other/match_statistics?match_id=${currentMatchId}`)
        const result = await response.json()
        
        if (result.code === 1 && result.data) {
          // 填充主队数据 (team_A)
          if (result.data.team_A) {
            homeTeamId.value = result.data.team_A.team_id
            homeYellowCards.value = result.data.team_A.yellow_cards || 0
            homeRedCards.value = result.data.team_A.red_cards || 0
            homeCorners.value = result.data.team_A.corners || 0
          }
          
          // 填充客队数据 (team_B)
          if (result.data.team_B) {
            awayTeamId.value = result.data.team_B.team_id
            awayYellowCards.value = result.data.team_B.yellow_cards || 0
            awayRedCards.value = result.data.team_B.red_cards || 0
            awayCorners.value = result.data.team_B.corners || 0
          }
        }
      } catch (error) {
        console.error('获取统计数据失败:', error)
      } finally {
        loading.value = false
      }
    }

    // 上传统计数据
    const uploadStatistics = async (teamId, stats) => {
      if (!matchId.value || !teamId) {
        console.warn('缺少 match_id 或 team_id，无法上传')
        return
      }
      
      try {
        const response = await fetch('https://api.zctj16888.com/app/v1/other/statistics', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            match_id: matchId.value,
            team_id: teamId,
            ...stats
          })
        })
        
        const result = await response.json()
        if (result.code !== 1) {
          console.error('上传统计数据失败:', result.msg)
        }
      } catch (error) {
        console.error('上传统计数据失败:', error)
      }
    }

    // 保存数据到本地存储并上传
    const saveStats = async () => {
      try {
        // 保存主队数据到本地存储
        localStorage.setItem('home_yellowCards', homeYellowCards.value.toString())
        localStorage.setItem('home_redCards', homeRedCards.value.toString())
        localStorage.setItem('home_corners', homeCorners.value.toString())
        
        // 保存客队数据到本地存储
        localStorage.setItem('away_yellowCards', awayYellowCards.value.toString())
        localStorage.setItem('away_redCards', awayRedCards.value.toString())
        localStorage.setItem('away_corners', awayCorners.value.toString())
        
        // 上传主队数据
        if (homeTeamId.value) {
          await uploadStatistics(homeTeamId.value, {
            yellow_cards: homeYellowCards.value,
            red_cards: homeRedCards.value,
            corners: homeCorners.value
          })
        }
        
        // 上传客队数据
        if (awayTeamId.value) {
          await uploadStatistics(awayTeamId.value, {
            yellow_cards: awayYellowCards.value,
            red_cards: awayRedCards.value,
            corners: awayCorners.value
          })
        }
        
        // 显示保存提示
        saveTip.value = true
        if (saveTipTimer) {
          clearTimeout(saveTipTimer)
        }
        saveTipTimer = setTimeout(() => {
          saveTip.value = false
        }, 1500)
      } catch (error) {
        console.error('保存数据失败:', error)
        alert('保存数据失败，请检查浏览器设置')
      }
    }

    // 主队黄牌
    const increaseHomeYellowCards = () => {
      homeYellowCards.value++
      saveStats()
    }
    const decreaseHomeYellowCards = () => {
      if (homeYellowCards.value > 0) {
        homeYellowCards.value--
        saveStats()
      }
    }

    // 客队黄牌
    const increaseAwayYellowCards = () => {
      awayYellowCards.value++
      saveStats()
    }
    const decreaseAwayYellowCards = () => {
      if (awayYellowCards.value > 0) {
        awayYellowCards.value--
        saveStats()
      }
    }

    // 主队红牌
    const increaseHomeRedCards = () => {
      homeRedCards.value++
      saveStats()
    }
    const decreaseHomeRedCards = () => {
      if (homeRedCards.value > 0) {
        homeRedCards.value--
        saveStats()
      }
    }

    // 客队红牌
    const increaseAwayRedCards = () => {
      awayRedCards.value++
      saveStats()
    }
    const decreaseAwayRedCards = () => {
      if (awayRedCards.value > 0) {
        awayRedCards.value--
        saveStats()
      }
    }

    // 主队角球
    const increaseHomeCorners = () => {
      homeCorners.value++
      saveStats()
    }
    const decreaseHomeCorners = () => {
      if (homeCorners.value > 0) {
        homeCorners.value--
        saveStats()
      }
    }

    // 客队角球
    const increaseAwayCorners = () => {
      awayCorners.value++
      saveStats()
    }
    const decreaseAwayCorners = () => {
      if (awayCorners.value > 0) {
        awayCorners.value--
        saveStats()
      }
    }

    // 重置所有统计
    const resetAllStats = () => {
      if (confirm('确定要重置所有统计数据吗？')) {
        homeYellowCards.value = 0
        homeRedCards.value = 0
        homeCorners.value = 0
        awayYellowCards.value = 0
        awayRedCards.value = 0
        awayCorners.value = 0
        saveStats()
      }
    }

    onMounted(async () => {
      // 先获取服务器数据
      await fetchStatistics()
    })

    return {
      homeYellowCards,
      homeRedCards,
      homeCorners,
      awayYellowCards,
      awayRedCards,
      awayCorners,
      saveTip,
      loading,
      increaseHomeYellowCards,
      decreaseHomeYellowCards,
      increaseAwayYellowCards,
      decreaseAwayYellowCards,
      increaseHomeRedCards,
      decreaseHomeRedCards,
      increaseAwayRedCards,
      decreaseAwayRedCards,
      increaseHomeCorners,
      decreaseHomeCorners,
      increaseAwayCorners,
      decreaseAwayCorners,
      resetAllStats
    }
  }
}
</script>

<style scoped>
.stats-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  overflow-y: auto;
}

.header {
  width: 100%;
  max-width: 500px;
  margin-bottom: 10px;
}

.title {
  font-size: 22px;
  font-weight: bold;
  color: white;
  text-align: center;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
  margin: 0;
}

.stats-content {
  width: 100%;
  max-width: 500px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.stat-card {
  background: white;
  border-radius: 15px;
  padding: 12px 15px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.stat-label {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  text-align: center;
  margin-bottom: 5px;
}

.teams-stats {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.team-stat {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 8px;
  background: #f8f9fa;
  border-radius: 10px;
}

.team-label {
  font-size: 16px;
  font-weight: 600;
  color: #666;
}

.stat-controls {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  width: 100%;
}

.btn {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: none;
  font-size: 28px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}

.btn:active {
  transform: scale(0.95);
}

.btn-minus {
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a6f 100%);
  color: white;
}

.btn-minus:disabled {
  background: #ccc;
  cursor: not-allowed;
  opacity: 0.6;
}

.btn-minus:not(:disabled):hover {
  background: linear-gradient(135deg, #ee5a6f 0%, #ff6b6b 100%);
  box-shadow: 0 4px 12px rgba(238, 90, 111, 0.4);
}

.btn-plus {
  background: linear-gradient(135deg, #4ecdc4 0%, #44a08d 100%);
  color: white;
}

.btn-plus:hover {
  background: linear-gradient(135deg, #44a08d 0%, #4ecdc4 100%);
  box-shadow: 0 4px 12px rgba(78, 205, 196, 0.4);
}

.btn-icon {
  line-height: 1;
  font-weight: 300;
}

.stat-value {
  font-size: 40px;
  font-weight: bold;
  color: #333;
  min-width: 60px;
  text-align: center;
  font-variant-numeric: tabular-nums;
}

.reset-section {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 5px;
}

.btn-reset {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: 2px solid white;
  border-radius: 20px;
  padding: 8px 30px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
}

.btn-reset:active {
  transform: scale(0.95);
}

.btn-reset:hover {
  background: rgba(255, 255, 255, 0.3);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.save-tip {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 15px 30px;
  border-radius: 25px;
  font-size: 18px;
  font-weight: 600;
  z-index: 1000;
  pointer-events: none;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* 移动端适配 */
@media (max-width: 480px) {
  .stats-container {
    padding: 8px;
  }

  .title {
    font-size: 20px;
    margin-bottom: 8px;
  }

  .stat-card {
    padding: 10px 12px;
    gap: 6px;
  }

  .stat-label {
    font-size: 18px;
    margin-bottom: 4px;
  }

  .stat-value {
    font-size: 36px;
  }

  .team-label {
    font-size: 14px;
  }

  .teams-stats {
    gap: 6px;
  }

  .team-stat {
    padding: 6px;
    gap: 6px;
  }

  .btn {
    width: 45px;
    height: 45px;
    font-size: 24px;
  }

  .stat-controls {
    gap: 12px;
  }

  .stats-content {
    gap: 8px;
  }

  .btn-reset {
    padding: 6px 24px;
    font-size: 14px;
  }
}

/* 防止双击缩放 */
@media (max-width: 768px) {
  .btn {
    touch-action: manipulation;
  }
}
</style>

